import { Stack, Typography, styled, Divider, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { MyTrainingsViewContext } from "context/myTrainings/MyTrainingsViewContext";
import { EmptyUserAvatar } from "components/EmptyUserAvatar/EmptyUserAvatar";
import { RoutePaths } from "constants/RoutePaths";

const UserAvatar = styled("img")({
    height: "56px",
    width: "56px",
    borderRadius: "50%",
    objectFit: "cover",
});

const WelcomeTypography = styled(Typography)({
    fontWeight: 600,
});

const SubtitleTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: "0.775rem",
}));

const SpacedDivider = styled(Divider)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const LoadingButtonContainer = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export const MobileHomeHeaderComponent = () => {
    const { t } = useTranslation();
    const { user, isStatisticOfLoggedUser } = useContext(MyTrainingsViewContext);
    const navigate = useNavigate();

    if (!user) return null;

    return (
        <>
            <Stack direction="row" alignItems="center" spacing={2}>
                {user.profilePhotoUrl ? (
                    <UserAvatar src={user.profilePhotoUrl} alt="User Avatar" />
                ) : (
                    <EmptyUserAvatar color="black" fontSize="2em" padding="1" />
                )}
                <Stack direction="column">
                    <WelcomeTypography>
                        {isStatisticOfLoggedUser
                            ? t("myTrainings.welcomeUser", { userName: user.displayName })
                            : t("myTrainings.welcomeInUserProgress", { userName: user.displayName })}
                    </WelcomeTypography>
                    <SubtitleTypography>
                        {isStatisticOfLoggedUser
                            ? t("myTrainings.checkYourLessons")
                            : t("myTrainings.checkUserProgress")}
                    </SubtitleTypography>
                </Stack>
            </Stack>

      <SpacedDivider />

            <LoadingButtonContainer>
                <LoadingButton
                    onClick={() => navigate(RoutePaths.HOME_QR)}
                    color="primary"
                    variant="contained"
                    fullWidth
                >
                    {t("mobileMenu.loginToVrWithQr")}
                </LoadingButton>
            </LoadingButtonContainer>
        </>
    );
};
